import { MutationTree } from 'vuex';
import { State } from './state';
import { CEadVal, CEadValPos, Entwurf, NEadSubPos, DocumentFile } from '@/modules/zelos/models/Zelos/ZelosModels';

export enum MutationTypes {
  SetEntwurfe = 'SETENTWURFE',
  UpdateNEadSub = 'UPDATENEADSUB',
  AddNEadSubPosRange = 'ADDNEADSUBPOSRANGE',
  SetNEadSubDoc = 'SETNEADSUBDOC',

  SetCEadVal = 'SETCEADVAL',
  AddCEadValPosRange = 'ADDCEADVALPOSRANGE',
}

export type Mutations = {
  [MutationTypes.SetEntwurfe](state: State, entwurfe: Array<Entwurf>): void;
  [MutationTypes.UpdateNEadSub](state: State, data: Entwurf): void;
  [MutationTypes.AddNEadSubPosRange](state: State, data: Array<NEadSubPos>): void;
  [MutationTypes.SetNEadSubDoc](state: State, doc: DocumentFile | null): void;

  [MutationTypes.SetCEadVal](state: State, data: Array<CEadVal>): void;
  [MutationTypes.AddCEadValPosRange](state: State, data: Array<CEadValPos>): void;
};

export const mutations: MutationTree<State> & Mutations = {
  [MutationTypes.SetEntwurfe](state: State, entwurfe: Array<Entwurf>) {
    state.entwurfe = entwurfe;
    sessionStorage.setItem('neadsub', JSON.stringify(state.entwurfe));
  },

  [MutationTypes.UpdateNEadSub](state: State, data: Entwurf) {
    const olddata = state.entwurfe.find((a) => a.id === data.id);
    if (olddata != null) {
      const index = state.entwurfe.indexOf(olddata);
      state.entwurfe.splice(index, 1, data);
    }

    sessionStorage.setItem('neadsub', JSON.stringify(state.entwurfe));
  },

  [MutationTypes.SetNEadSubDoc](state: State, doc: DocumentFile | null) {
    state.neadsubDoc = doc;
  },

  [MutationTypes.AddNEadSubPosRange](state: State, data: Array<NEadSubPos>) {
    state.neadsubpos.push(...data);
    sessionStorage.setItem('neadsubpos', JSON.stringify(state.neadsubpos));
  },

  [MutationTypes.SetCEadVal](state: State, data: Array<CEadVal>) {
    state.ceadval = data;
    sessionStorage.setItem('ceadval', JSON.stringify(state.ceadval));
  },

  [MutationTypes.AddCEadValPosRange](state: State, data: Array<CEadValPos>) {
    state.ceadvalpos.push(...data);
    sessionStorage.setItem('ceadvalpos', JSON.stringify(state.ceadvalpos));
  },
};
